import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { SubjectSearch } from './Subject/SubjectSearch';
import { ActionTypes, Subject } from './common/models';

interface SearchComponentProps extends RouteComponentProps<any> {}

interface SearchComponentState {}

export class SearchComponentImpl extends React.Component<SearchComponentProps, SearchComponentState> {
  constructor(props: SearchComponentProps) {
    super(props);
    this.state = {};
  }

  selectSubject = (subject?: Subject) => {
    if (subject && this.props.history) {
      this.props.history.push(subject.getRoute());
    }
  };

  render() {
    return (
      <SubjectSearch
        className="header-search"
        autoFocus={true}
        onSelect={this.selectSubject}
        clearOnSelect={true}
        action={ActionTypes.VIEW}
      />
    );
  }
}

export const SearchComponent = withRouter(SearchComponentImpl);



// WEBPACK FOOTER //
// ./src/SearchComponent.tsx